import { __, __r } from 'react-i18n/lib';
import { Link } from 'react-router';
import {
  DsiCheckBox as CheckBox,
  DsiPasswordMeter as PasswordMeter,
  DsiSvgIcon as SvgIcon,
  ErrorAlert,
  FlexRowCenter,
  FlexRowCenterVertical,
  InfoText,
  TextP,
  DsiInfoText,
  DsiInfoType,
} from '../../..';
import { InfoType } from '../../Zemplin/General/InfoText';
import {
  FormInput,
  LoginButton,
  StyledLabel,
  Wrapper,
  secondaryText,
} from './LoginForm';
import { StyledLabel as PrivacyLabel } from '../Category/ProductFilterItem';
import { Loader } from '../../Zemplin/General/Loader';
import { IconType } from '../General/SvgIcon';
import * as React from 'react';
import styled from 'styled-components';
import { rem } from 'polished';
import {
  Form,
  Header,
  Required,
  StyledCheckBoxWrapper,
  StyledRegister,
} from './RegisterForm';
import { DsiPasswordEye } from './PasswordEye';
import { removeDiacritics } from '../Cart/utilities';

interface Props {
  cartId: string | undefined;
  handleFormSubmit: any;
  handleGoogleLogin: any;
  isFetching: boolean;
  successMessage: string;
  errorMessage: string;
  sendAsBody?: boolean;
}

function EndRegisterForm({
  cartId,
  handleFormSubmit,
  handleGoogleLogin,
  isFetching,
  successMessage,
  errorMessage,
  sendAsBody,
}: Props) {
  const [email, setEmail] = React.useState('');
  const [password, setPassword] = React.useState('');
  const [confirmPassword, setConfirmPassword] = React.useState('');
  const [isPrivacySelected, setIsPrivacySelected] = React.useState(false);
  const [isNewsletterAccept, setIsNewsletterAccept] = React.useState(false);
  const [isGoogleLogin, setIsGoogleLogin] = React.useState(false);
  const [showPassword, setShowPassword] = React.useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = React.useState(false);

  const formRef = React.useRef(null);
  React.useEffect(() => {
    const handleKeyDown = event => {
      if (event.key === 'Enter' && formRef?.current) {
        const current: any = formRef?.current;
        current.requestSubmit();
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  const changePrivacySelected = () => {
    setIsPrivacySelected(!isPrivacySelected);
  };

  const changeNewsletterAccept = () => {
    setIsNewsletterAccept(!isNewsletterAccept);
  };

  const googleLogin = e => {
    setIsGoogleLogin(true);
    handleForm(e);
  };

  const handleForm = e => {
    console.log('HANDLE FORM!!');

    e.preventDefault();
    if (!isGoogleLogin) {
      if (sendAsBody) {
        handleFormSubmit({
          email,
          password,
          confirmPassword,
          termsAccept: isPrivacySelected,
          newsletter_accept: isNewsletterAccept,
          b2c: true,
        });
      } else {
        handleFormSubmit(
          email,
          password,
          confirmPassword,
          isPrivacySelected,
          isNewsletterAccept,
        );
      }
    } else {
      handleGoogleLogin();
    }
  };

  const handleInvalid = event => {
    event.target.setCustomValidity(__('Do adresy uveďte znak „@“.'));
  };

  const handleInput = event => {
    event.target.setCustomValidity('');
  };

  const toogleShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const toogleShowConfirmPassword = () => {
    setShowConfirmPassword(!showConfirmPassword);
  };

  return (
    <Wrapper>
      <Header>{`${__('Registrácia')}`}</Header>

      {successMessage && (
        <InfoText type={InfoType.SUCCESS} info={successMessage} />
      )}
      <Form ref={formRef} onSubmit={handleForm}>
        <StyledLabel htmlFor="email">
          {`${__('Email')}`}
          <Required>{`*`}</Required>
        </StyledLabel>
        <FormInput
          autocomplete="email"
          type="email"
          value={email}
          placeholder={'@'}
          name="email"
          // tslint:disable-next-line:jsx-no-lambda
          onChange={e => setEmail(removeDiacritics(e.target.value))}
          tabIndex={1}
          marginBottom={0}
          required={true}
          onInvalid={handleInvalid}
          onInput={handleInput}
        />
        <StyledLabel htmlFor="password">
          {`${__('Heslo')}`}
          <Required>{`*`}</Required>
        </StyledLabel>
        <PasswordWrapper>
          <FormInput
            autocomplete="new-password"
            type={showPassword ? 'text' : 'password'}
            value={password}
            name="password"
            // tslint:disable-next-line:jsx-no-lambda
            onChange={e => setPassword(e.target.value)}
            tabIndex={2}
            marginBottom={0}
            required={true}
          />
          <PasswordEye>
            <DsiPasswordEye
              isPasswordVisible={showPassword}
              onClick={() => toogleShowPassword()}
            />
          </PasswordEye>
        </PasswordWrapper>
        <PasswordMeter password={password} />
        <br />
        <StyledLabel htmlFor="password">
          {`${__('Potvrďte heslo')}`}
          <Required>{`*`}</Required>
        </StyledLabel>
        <PasswordWrapper>
          <FormInput
            type={showConfirmPassword ? 'text' : 'password'}
            value={confirmPassword}
            name="confirm-password"
            // tslint:disable-next-line:jsx-no-lambda
            onChange={e => setConfirmPassword(e.target.value)}
            tabIndex={2}
            marginBottom={0}
            required={true}
          />
          <PasswordEye>
            <DsiPasswordEye
              isPasswordVisible={showConfirmPassword}
              onClick={() => toogleShowConfirmPassword()}
            />
          </PasswordEye>
        </PasswordWrapper>
        <StyledCheckBoxWrapper>
          <CheckBox
            name={'privacy'}
            type={'checkbox'}
            selected={isPrivacySelected}
            onClick={changePrivacySelected}
            required={true}
          />
          <PrivacyLabel htmlFor={'privacy'} selected={isPrivacySelected}>
            {__(`Súhlasím so spracovaním`)}
            <Link
              to={__r(
                'routes:spracovanie-osobnych-udajov',
                '/spracovanie-osobnych-udajov',
              )}
            >
              <StyledRegister selected={isPrivacySelected}>
                {__(`osobných údajov`)}
              </StyledRegister>
            </Link>
          </PrivacyLabel>
        </StyledCheckBoxWrapper>

        <StyledCheckBoxWrapper>
          <CheckBox
            name={'newsletter_accept'}
            type={'checkbox'}
            selected={isNewsletterAccept}
            onClick={changeNewsletterAccept}
          />
          <StyledLabel>
            {__('Súhlasím so začlenením do newslettera')}
          </StyledLabel>
        </StyledCheckBoxWrapper>

        {errorMessage ? (
          <DsiInfoText
            marginBottom={0}
            marginTop={12}
            type={DsiInfoType.ERROR}
            info={__(errorMessage)}
          />
        ) : (
          <></>
        )}

        <LoginButton type="submit">
          {isFetching ? (
            <FlexRowCenter>
              {`${__('Registrujem')}...`}
              <Loader className="marginLeft" small={true} />
            </FlexRowCenter>
          ) : (
            __('Registrovať sa')
          )}
        </LoginButton>
        <PasswordLink to={__r('routes:zabudnute-heslo', '/zabudnute-heslo')}>
          <ForgotPassword>{__('Zabudli ste heslo')}?</ForgotPassword>
        </PasswordLink>
        {/*
        <Delimiter>
          <Line />
          <DelimiterText>{`${__('alebo')}`}</DelimiterText>
          <Line />
        </Delimiter>
        <StyledLoginButton onClick={handleGoogleLogin}>
          <FlexRowCenterVertical>
            <StyledSvgIcon icon={IconType.google} fill={'#FFFFFF'} />
            {`${__('Pokračovať cez Google')}`}
          </FlexRowCenterVertical>
        </StyledLoginButton>
        */}
      </Form>
    </Wrapper>
  );
}

const Delimiter = styled(FlexRowCenterVertical)`
  margin-bottom: ${rem(32)};
`;

const Line = styled.div`
  width: 100%;
  height: ${rem(1)};
  background-color: #eeeeee;
`;

const DelimiterText = styled(TextP)`
  margin: 0 ${rem(8)};
`;

const StyledLoginButton = styled(LoginButton)`
  background-color: #4285f4;
  margin-bottom: 0;
`;

const StyledSvgIcon = styled(SvgIcon)`
  margin-right: ${rem(16)};
`;

const PasswordLink = styled(Link)`
  text-decoration-color: ${({ theme }) => theme.colors.primary};
`;

const ForgotPassword = styled.p`
  ${secondaryText};
  color: ${({ theme }) => theme.colors.primary};
  text-align: right;
  margin: ${rem(16)} 0 0;
  width: 100%;
`;

const PasswordWrapper = styled.div`
  position: relative;
`;

const PasswordEye = styled.div`
  position: absolute;
  right: ${rem(10)};
  bottom: ${rem(15)};
`;

export { EndRegisterForm as DsiEndRegisterForm };
